import styled from "styled-components";
import SwiperComponent from "./index";
import { ReactNode } from "react";

export default function GuideSlideBox(props: {
  initialSlideNum?: number;
  goNextOnceAndStop?: boolean;
  slideContents: ReactNode[];
}) {
  return (
    <>
      <ContentContainer>
        <SwiperComponent
          initialSlide={props.initialSlideNum}
          goNextOnceAndStop={props.goNextOnceAndStop}
          slideContentList={props.slideContents}
          swiperKey="yb-guide"
        />
      </ContentContainer>
      {/* }
      /> */}
    </>
  );
}

const ContentContainer = styled.div`
  padding: 18px;
  .swiper {
    z-index: 0;
  }
  .swiper-scrollbar,
  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
  img {
    width: 100%;
  }
  .swiper-pagination {
    position: absolute;
    bottom: 15px;
    left: 15px;
    width: auto;
  }
  .swiper-pagination-bullet {
  }
  .swiper-pagination-bullet-active {
    background-color: #3e3e3e;
  }
`;
